import { Injectable } from '@angular/core'
import { BaseModelService } from './base-model.service'
import { Program } from './program.model'
import { ProgramSerializer } from 'serializers'
import { Observable } from 'rxjs/Observable'

export interface CoursesListResponse {
  courses: {
    label: string
    value: string
  }[]
}

export interface CompletedSessionsCountResponse {
  program_id: number
  couunt: number
}

interface KioskProgram {
  name: string,
  uuid: string
}

@Injectable()
export class ProgramService extends BaseModelService<Program> {
  constructor() {
    super()

    this.configure({
      basePath:  'programs',
      key:       'program',
      pluralKey: 'programs',
      serializer: ProgramSerializer
    })
  }

  coursesList(): Observable<CoursesListResponse> {
    let url = this.buildUrl('courses_list')
    return this.get(url).map(resp => resp as CoursesListResponse).map(resp => {
      let baseCourse = resp.courses.find(course => course.value == null)
      if (baseCourse) {
        baseCourse.label = "Базовый"
      }
      return resp
    })
  }

  kioskProgramsList(): Observable<Array<KioskProgram>> {
    let url = this.buildUrl('kiosk_programs_list')
    return this.get(url).map(resp => resp['programs'] as Array<KioskProgram>)
  }

  loadCompletedSessionsCount(programs: Program[]): Observable<CompletedSessionsCountResponse[]> {
    let url = this.buildUrl('completed_sessions_count_index')
    let ids = programs.map(p => p.id)
    return this.get(url, { program_ids: ids }).map(r => {
      let counts = r['completedSessionsCountIndex']
      return Object.keys(counts).map(k => {
        return { program_id: +k, couunt: counts[k] }
      })
    })
  }

  alert(): void{
    console.log('fuck')
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/program.service.ts